var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.Button,
    {
      staticClass: "btn-sm",
      attrs: { "active-value": _setup.sortAlpha },
      nativeOn: {
        click: function ($event) {
          return _setup.toggleSortAlpha.apply(null, arguments)
        },
      },
    },
    [_c("i", { staticClass: "bi bi-sort-alpha-down" })]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }